import React from 'react';
import size from 'lodash/size';

import styles from './descriptionBlock.module.css';

function DescriptionBlock({ description = '' }) {
  if (!size(description)) return null;
  return (
    <div className={styles.container}>
      <div className={styles.header}>Description</div>
      <div className={styles.description}>{description}</div>
    </div>
  );
}

export default React.memo(DescriptionBlock);
